import stringSimilarity from "string-similarity";

export function getDidYouMean(keys: string[] = [], key = "") {
  if (!keys.length) {
    return "";
  }
  const { bestMatch } = stringSimilarity.findBestMatch(key, keys);
  return bestMatch.rating > 0.6 ? ` Did you mean "${bestMatch.target}"?` : "";
}
